import _classCallCheck from "/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
/**
 * A request to confirm a {@link Session} (incoming ACK).
 * @public
 */
export var Ack = /*#__PURE__*/function () {
  /** @internal */
  function Ack(incomingAckRequest) {
    _classCallCheck(this, Ack);
    this.incomingAckRequest = incomingAckRequest;
  }
  /** Incoming ACK request message. */
  _createClass(Ack, [{
    key: "request",
    get: function get() {
      return this.incomingAckRequest.message;
    }
  }]);
  return Ack;
}();